import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-revitalized-competitive-cities',
    imports: [TranslateModule],
    templateUrl: './revitalized-competitive-cities.component.html',
    styleUrl: './revitalized-competitive-cities.component.scss'
})
export class RevitalizedCompetitiveCitiesComponent {}
